const PURCHASE_TYPE_LABELS: Record<string, string> = {
  HONEY: 'Honung',
  POLLEN: 'Pollen',
  PACKAGING: 'Emballage',
  BEESWAX: 'Bivax',
  PRODUCT: 'Produkter',
};

const PURCHASE_STATUS_LABELS: Record<string, string> = {
  SENT: 'Skickad',
  PARTIAL_RECEIVED: 'Delvis mottagen',
  RECEIVED: 'Mottagen',
  CANCELLED: 'Avbruten',
};

export function purchaseTypeLabel(value: string | null | undefined, fallback?: string | null): string {
  const normalized = (value ?? '').trim();
  if (normalized === '') return fallback ?? '-';
  return PURCHASE_TYPE_LABELS[normalized] ?? fallback ?? normalized;
}

export function purchaseStatusLabel(value: string | null | undefined): string {
  const normalized = (value ?? '').trim();
  if (normalized === '') return '-';
  return PURCHASE_STATUS_LABELS[normalized] ?? normalized;
}
